import { LoggerLevelEnum } from "@/enums";
import type { LoggerLevel } from "@/types";

export function parseLoggerLevel(value: unknown): LoggerLevel | undefined {
  if (typeof value !== "string") return undefined;
  const s = value.trim().toLowerCase();
  if (!s) return undefined;

  switch (s) {
    case LoggerLevelEnum.DEBUG:
      return LoggerLevelEnum.DEBUG;
    case LoggerLevelEnum.INFO:
      return LoggerLevelEnum.INFO;
    case LoggerLevelEnum.WARN:
    case "warning":
      return LoggerLevelEnum.WARN;
    case LoggerLevelEnum.ERROR:
      return LoggerLevelEnum.ERROR;
    case LoggerLevelEnum.FATAL:
      return LoggerLevelEnum.FATAL;
    default:
      return undefined;
  }
}
